module.exports = __webpack_public_path__ + "img/disaster_relief-stage_3.4.3e9e20e4.jpg";